export default "__VITE_ASSET__CcS7ziW2__"